import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  generateMOM,
  getAgendaWithMinutesDetails,
  processCancelMeeting,
  processdeleteMeeting,
} from "../../redux/actions/meetingActions/MeetingAction";
import ViewMinutes from "./ViewMinutes";
import "./minutes.css";
import CreateMinutes from "./CreateMinutes";
import { logOut } from "../../redux/actions/authActions/authAction";
import ViewParentActions from "./ViewParentActions";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import Alert from "../Common/Alert";
import GenerateMOMModal from "./GenerateMOMModal";
import MeetingDropDown from "../Meeting/MeetingDropDown";
import Dropdown from "react-bootstrap/Dropdown";
import RescheduleMeetingModal from "../Meeting/RescheduleMeetingModal";
import ResendMeetingDetailsModal from "../Meeting/ResendMeetingDetailsModal";
import CancelMeetingModal from "../Meeting/CancelMeetingModal";
import DeleteMeetingModal from "../Meeting/DeleteMeetingModal";
import BackButton from "../Common/Backbutton";

const MinutesPage = (props) => {
  let { meetingId } = useParams();
  const dispatch = useDispatch();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const meetingData = useSelector((state) => state.meeting);
  const accessToken = localStorage.getItem("accessToken");
  const minuteData = useSelector((state) => state.minute);
  const [meetingIds, setMeetingIds] = useState(null);
  const [openAgendaForm, setOpenAgendaForm] = useState(false);
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [isDeleteMeetingModalOpen, setIsDeleteMeetingModalOpen] =
    useState(false);
  const [singleMeetingDetails, setSingleMeetingDetails] = useState(null);
  const [isResendMeetingDetailsModalOpen, setIsResendMeetingDetailsModalOpen] =
    useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  useEffect(() => {
    if (accessToken) {
      dispatch(getAgendaWithMinutesDetails(meetingId, accessToken));
    }

    return () => {};
  }, [minuteData.isSuccess]);

  const openAgenda = () => {
    setOpenAgendaForm(!openAgendaForm);
  };

  const closeAgenda = () => {
    setOpenAgendaForm(false);
  };

  const generateMOMDetails = async () => {
    const meetingId = props.meetingId
      ? props.meetingId
      : meetingData.meetingDetails?._id;
    const payload = {
      organizationId: userData.organizationId,
      attendees: meetingData?.meetingDetails?.attendees?.map(
        ({
          rsvp,
          isAttended,
          isEmployee,
          empId,
          designation,
          companyName,
          ...keepAttrs
        }) => keepAttrs
      ),
    };

    const result = await dispatch(generateMOM(meetingId, payload, accessToken));

    if (result?.status) {
      setIsCloseModalOpen(false);
    }
  };
  const handleGenerateMOMModal = () => {
    setIsCloseModalOpen(true);
  };

  const handleCancelModal = (meetingId) => {
    setMeetingIds(meetingId);
    setIsCancelModalOpen(true);
  };

  const handleResendMeetingDetailsModal = (singleMeetingDetails) => {
    setSingleMeetingDetails(singleMeetingDetails);
    setIsResendMeetingDetailsModalOpen(true);
  };

  const handleRescheduleModal = (singleMeetingDetails) => {
    setSingleMeetingDetails(singleMeetingDetails);

    setIsRescheduleModalOpen(true);
  };

  const handleCloseModal = (meetingId) => {
    setMeetingIds(meetingId);
    setIsCloseModalOpen(true);
  };

  ////////////// delete meeting //////////////

  const handleDeleteModal = (meetingId) => {
    setMeetingIds(meetingId);
    setIsDeleteMeetingModalOpen(true);
  };

  const handleDeleteMeeting = () => {
    dispatch(processdeleteMeeting(meetingId, accessToken));
    setMeetingIds(null);
    setTimeout(() => {
      navigate("/meeting-list");
    }, 500);
  };

  let meetingDetailss = meetingData?.meetingDetails;
  if (meetingData?.agendaDetails?.length !== 0) {
    const actionDetails = meetingData?.agendaDetails?.find(
      (agenda) => agenda?.minutesDetail?.length !== 0
    );
    meetingDetailss["actionDetail"] = actionDetails ? [actionDetails] : [];
  }

  const handleCancelMeeting = (remarks) => {
    if (!authData.isInValidUser) {
      dispatch(processCancelMeeting(meetingId, { remarks }, accessToken));
    }
    setMeetingIds(null);
    setIsCancelModalOpen(false);
  };

  return (
    <>
      {meetingData?.meetingDetails !== null ? (
        <div className="main-content">
          <div className="page-heading d-flex justify-content-between align-items-center mb-0">
            <div className="meeting-header-text line-height-h4">
              <h4>Write Minutes</h4>
            </div>
            <div className="right-agenda-div d-flex">
              {meetingData?.meetingDetails?.isMinutesAdded ? (
                <div className="agenda-btn-icon screen-hide-380">
                  <button
                    type="button"
                    className="create-meeting-button Mom-btn btn btn-primary filter-height"
                    onClick={handleGenerateMOMModal}
                  >
                    <p>Generate MOM</p>
                  </button>
                </div>
              ) : null}

              {meetingData?.statusData !== "cancelled" && (
                <div className="d-inline-block menu-dropdown custom-dropdown inner-mt">
                  <Dropdown>
                    <MeetingDropDown
                      meetingDetails={meetingDetailss}
                      meetingId={meetingDetailss?._id}
                      status={meetingDetailss?.meetingStatus?.status}
                      handleCancelModal={() =>
                        handleCancelModal(meetingData?.meetingDetails?._id)
                      }
                      handleResendMeetingDetailsModal={() =>
                        handleResendMeetingDetailsModal(
                          meetingData?.meetingDetails
                        )
                      }
                      handleRescheduleModal={() =>
                        handleRescheduleModal(meetingData?.meetingDetails)
                      }
                      handleCloseModal={() =>
                        handleCloseModal(meetingData?.meetingDetails?._id)
                      }
                      handleDeleteModal={() => {
                        handleDeleteModal(meetingData?.meetingDetails?._id);
                      }}
                    />
                  </Dropdown>
                </div>
              )}
              <BackButton show={camefromPreviousPage} />
            </div>
          </div>

          <div className="row">
            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
              <CreateMinutes
                openAgendaForm={openAgendaForm}
                closeAgendaForm={closeAgenda}
              />
              {meetingData?.meetingDetails?.parentMeetingId ? (
                <form className="mt-4">
                  <ViewParentActions
                    parentMeetingId={
                      meetingData?.meetingDetails?.parentMeetingId
                    }
                    childMeetingId={meetingData?.meetingDetails?._id}
                  />
                </form>
              ) : null}
            </div>

            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 detail-col res-mt-20">
              <ViewMinutes openAgendaForm={openAgenda} inWriteMinute={true} />
            </div>
          </div>
        </div>
      ) : meetingData?.meetingDetails === null &&
        !meetingData?.loading &&
        !meetingData.isSuccess ? (
        <div className="main-content">
          <div className="meeting-header-text  line-height-h4">
            <h4>Write Minutes</h4>
          </div>

          <form className="mt-2 details-form details-form-right">
            <div className="no-data-img mt-3">
              <Alert
                status={"info"}
                message={"No data available."}
                timeoutSeconds={0}
              />
              <NoDataFound dataType={"meeting"} />
            </div>
          </form>
        </div>
      ) : (
        <div>
          <div className="meeting-header-text line-height-h4">
            <h4>Write Minutes</h4>
          </div>
          <Loader />
        </div>
      )}
      <GenerateMOMModal
        message={"Do you want to generate the MOM report ?"}
        title={"Generate MOM"}
        setIsModalOpen={setIsCloseModalOpen}
        isModalOpen={isCloseModalOpen}
        handleSubmit={generateMOMDetails}
        buttonName={"Cancel"}
        isCalledFromOthers={true}
      />

      <RescheduleMeetingModal
        setIsRescheduleModalOpen={setIsRescheduleModalOpen}
        isRescheduleModalOpen={isRescheduleModalOpen}
        meetingData={meetingData?.meetingDetails}
        isFetchedMeetingList={meetingData.isFetchedMeetingList}
        isNewMeeting={false}
      />

      <ResendMeetingDetailsModal
        isResendMeetingDetailsModalOpen={isResendMeetingDetailsModalOpen}
        setIsResendMeetingDetailsModalOpen={setIsResendMeetingDetailsModalOpen}
        meetingDetail={singleMeetingDetails}
      />

      <CancelMeetingModal
        setIsModalOpen={setIsCancelModalOpen}
        isModalOpen={isCancelModalOpen}
        handleSubmit={handleCancelMeeting}
      />
      <DeleteMeetingModal
        setIsModalOpen={setIsDeleteMeetingModalOpen}
        isModalOpen={isDeleteMeetingModalOpen}
        handleSubmit={handleDeleteMeeting}
      />
    </>
  );
};

export default MinutesPage;
